import { createSlice } from "@reduxjs/toolkit";
import HbsBorcTaahhutDTO from "src/models/HastaKayit/HbsBorcTaahhutDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

export class BorcTaahhutSearch {
  kimlikId: number = 0;
  muracaatId: number = 0;
  sadeceBorcOlanlar: boolean = true;
  hastayaGore: boolean = false;
  iptalGosterme: boolean = true;
}

interface IBorcTaahhutState {
  searchModel: BorcTaahhutSearch,
  activeRow: HbsBorcTaahhutDTO,
  listeOpen: boolean,
  detayOpen: boolean,
}
const BorcTaahhutSlice = createSlice<IBorcTaahhutState, MapReducerPayloads<IBorcTaahhutState, {
  setState: IBorcTaahhutState
}>>({
  name: 'BorcTaahhut',
  initialState: {
    searchModel: new BorcTaahhutSearch(),
    activeRow: new HbsBorcTaahhutDTO(),
    listeOpen: false,
    detayOpen: false,    
  },
  reducers: {
    setState: (state, action) => action.payload
  }
})
export default BorcTaahhutSlice;